import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import resumeData from '../../Utils/resumeData'
import TimelineDot from '@material-ui/lab/TimelineDot';

const About = () => {
    return (
        <div>
            <Grid container className='section pb_45' >
                <Grid item className="sectionTitle mb_30" >
                    <span></span>
                    <h6  className="sectiontitle_text " >Abouth Me</h6>
                </Grid>
                <Grid xs={12}>
                    <Typography variant="body2" className="aboutme_txt" >
                            {resumeData.AboutThereact}
                    </Typography>
                </Grid>

                <Grid item className="sectionTitle mb_30" style={{marginTop:"10px"}} >
                    <span></span>
                    <h6  className="sectiontitle_text " >Abouth React</h6>
                </Grid>
                <Grid xs={12} spacing={4}>
                    <Typography variant="body2" className="aboutme_txt" >
                            {resumeData.aboutReact}
                    </Typography>
                </Grid>

                <Grid item className="sectionTitle mb_30" style={{marginTop:"10px"}}>
                    <span></span>
                    <h6  className="sectiontitle_text " >Abouth Python</h6>
                </Grid>
                <Grid xs={12} spacing={4}>
                    <Typography variant="body2" className="aboutme_txt" >
                            {resumeData.aboutPython}
                    </Typography>
                </Grid>

                

           </Grid>
        </div>
    );
};

export default About;